import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'

import { dateFormat } from 'shared/lib/dateFormat'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import { SearchParams } from './components/search-params/search-params'
import s from './styles.module.scss'

const Header = observer(() => {
  const navigate = useNavigate()

  const onGoBack = () => {
    navigate(RoutingPaths.excursion.path())
  }

  const { name, direction, departure_date } = findExcursionsStore.findExcursions

  const onShowForm = () => {
    navigate(RoutingPaths.excursion.searchForm.path())
  }
  return (
    <div className={clsx('safe-area-top-padding', s.headerWrapper)}>
      <div className={s.header}>
        <AppIcon
          width={24}
          height={24}
          onClick={onGoBack}
          className={s.icon}
          id={AllIcons.ARROW_LEFT}
        />

        <SearchParams
          direction={name || direction}
          onShowForm={onShowForm}
          textDirection={`${dateFormat(departure_date)}`}
        />
      </div>
    </div>
  )
})

export default Header
